class BCommandStack {
	constructor() {
		this.doneStack = [];

		this.redoCandidates = [];
	}

	push(cmd) {
		this.doneStack.push(cmd);
	}

	canUndo() {
		return this.doneStack.length > 0;
	}

	canRedo() {
		return this.redoCandidates.length > 0;
	}

	undoLast(app) {
		if (!this.canUndo()) { return null; }
		
		const cmd = this.doneStack.pop();
		cmd.undo(app);

		this.redoCandidates.push(cmd);
		return cmd;
	}

	invalidateRedo() {
		this.redoCandidates.length = 0;
		return this;
	}

	redo(app) {
		if (!this.canRedo()) { return null; }

		const cmd = this.redoCandidates.pop();
		cmd.execute(app);

		this.doneStack.push(cmd);
		return cmd;
	}
}

export default BCommandStack;